import React, { ReactNode, VFC } from 'react';
import { Route } from 'react-router-dom';
import AppViewLayout from '../Layouts/AppViewLayout';

interface Props {
  path: string;
  children: ReactNode;
}
const AppViewLayoutRoute: VFC<Props> = ({ path, children }: Props) => {
  return (
    <Route path={path}>
      <AppViewLayout>{children}</AppViewLayout>
    </Route>
  );
};

export default AppViewLayoutRoute;
